import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input} from '@angular/core';
import {ControlContainer, FormGroup} from '@angular/forms';

import {UserModel} from '../../../shared/models/user.model';
import {UtilsService} from '../../../shared/services/utils.service';
import moment from 'moment';
import {ItemListProvider, MultiSelectSearchDropdownOption} from 'src/app/shared/components/multiselect-search-dropdown/item-list.provider';
import {AssigneeService} from 'src/app/requests/services/assignee.service';
import {Observable, BehaviorSubject} from 'rxjs';
import {map} from 'rxjs/operators';

class UserListDataSource extends ItemListProvider {
  constructor(private userService: AssigneeService) {
    super();
  }

  private makeLabel(user: UserModel) {
    return [user.firstName, user.lastName].filter(v => v).join(' ');
  }

  loadValues(values: string[]): Observable<MultiSelectSearchDropdownOption[]> {
    return this.userService
      .loadValues(values)
      .pipe(map(users => users.map(user => ({label: this.makeLabel(user), value: user.userName}))));
  }
  searchValues(query: string): Observable<MultiSelectSearchDropdownOption[]> {
    return this.userService
      .searchValues(query)
      .pipe(map(users => users.map(user => ({label: this.makeLabel(user), value: user.userName}))));
  }
  searchUsers(query: string): Observable<UserModel[]> {
    return this.userService
      .searchValues(query)
      .pipe(map(users => users));
  }
}

@Component({
  selector: 'app-edit-substitute-form',
  templateUrl: './edit-substitute-form.component.html',
  styleUrls: ['./edit-substitute-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EditSubstituteFormComponent {
  @Input() multipleDelegates = false;

  testId = 'substitute_form';
  get form(): FormGroup {
    return this.controlContainer.control as FormGroup;
  }
  today = moment().format('YYYY-MM-DD');

  compareUserFn = (o1: UserModel, o2: UserModel) => {
    if (o1?.userName && o2?.userName) {
      return o1.userName === o2.userName;
    }
    return false;
  };

  public userListProvider = new UserListDataSource(this.assigneeService);

  constructor(
    private controlContainer: ControlContainer,
    public utilsService: UtilsService,
    private assigneeService: AssigneeService,
    private cd: ChangeDetectorRef
  ) {}

  public userSearch: any = [];
  isUserLoading = new BehaviorSubject<boolean>(false);

  public getUserLabel(user: UserModel): string {
    return [user.firstName, user.lastName].filter(v => v).join(' ');
  }

  public getUsers(name: string): void {
    this.isUserLoading.next(true);
    this.userListProvider.searchUsers(name).subscribe(
      data => {
        this.userSearch = data;
        this.cd.detectChanges();
        this.isUserLoading.next(false);
      },
      () => {
        this.isUserLoading.next(false);
      }
    );
  }
}
